export const formEffect = (setForm, formValue) => () =>
  setForm({ ...formValue });
